import { render, staticRenderFns } from "./OrderTypeSwitchConfig.vue?vue&type=template&id=d701652e"
import script from "./OrderTypeSwitchConfig.vue?vue&type=script&lang=js"
export * from "./OrderTypeSwitchConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports